import { Text, TextProps } from "@chakra-ui/react";

const formatter = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatMoneyCents = (cents: number | null | undefined) => {
  const n = Number.isFinite(cents) ? Number(cents) / 100 : 0;
  return formatter.format(n);
};

export const Money = ({
  cents,
  ...rest
}: { cents: number | null | undefined } & TextProps) => (
  <Text as="span" {...rest}>
    {formatMoneyCents(cents)}
  </Text>
);
